import { render, staticRenderFns } from "./LocalCss.vue?vue&type=template&id=1aaa2d84&scoped=true"
import script from "./LocalCss.vue?vue&type=script&lang=js"
export * from "./LocalCss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaa2d84",
  null
  
)

export default component.exports